export enum ComponentState {
  DEFAULT,
  IN_PROGRESS,
  COMPLETE,
  INVALID,
}
